/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */
export const GET_SITE_PROPERTIES = 'GET_SITE_PROPERTIES';
export const GET_SEARCH_SETTINGS = 'GET_SEARCH_SETTINGS';
export const GET_SEARCHED_TERMS = 'GET_SEARCHED_TERMS';
export const GET_SIORG_ORGANS_LIST = 'GET_SIORG_ORGANS_LIST';
export const GET_USER_HISTORY = 'GET_USER_HISTORY';
export const GET_RECOMMENDATIONS = 'GET_RECOMMENDATIONS';
export const GET_GOV_HOME_SERVICES = 'GET_GOV_HOME_SERVICES';
export const GET_GOVBR_MENU = 'GET_GOVBR_MENU';
export const GET_AUDIT_LOG = 'GET_AUDIT_LOG';
export const RESET_AUDIT_LOG = 'RESET_AUDIT_LOG';
export const GET_AUDIT_LOG_CSV = 'GET_AUDIT_LOG_CSV';
export const GET_PORTAL_TYPES = 'GET_PORTAL_TYPES';
export const GET_PROFILE_REPORT = 'GET_PROFILE_REPORT';
export const GET_PROFILE_REPORT_CSV = 'GET_PROFILE_REPORT_CSV';
export const GET_SEARCH_UF = 'GET_SEARCH_UF';
export const GET_PUBLIC_CONSULTATIONS = 'GET_PUBLIC_CONSULTATIONS';
export const GET_SITE_AUDIT = 'GET_SITE_AUDIT';

export const UPLOAD_IMAGE_WITH_METADATA_REQUEST =
  'UPLOAD_IMAGE_WITH_METADATA_REQUEST';
export const UPLOAD_IMAGE_WITH_METADATA_SUCCESS =
  'UPLOAD_IMAGE_WITH_METADATA_SUCCESS';
export const UPLOAD_IMAGE_WITH_METADATA_FAILURE =
  'UPLOAD_IMAGE_WITH_METADATA_FAILURE';

export const CLOSE_IMAGE_MODAL = 'CLOSE_IMAGE_MODAL';
